import React from "react";
import { Radio } from "antd";
import styled from "styled-components";
import { FilterState } from "./useFilterState";

const Bar = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  gap: 12px;
  margin-bottom: 16px;
`;

const Label = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: #333;
  flex-shrink: 0;
`;

const GroupWrap = styled.div`
  flex: 1;
  min-width: 0;

  .ant-radio-button-wrapper {
    white-space: nowrap;
  }
`;

export const StatusFilterBar = (props: { filters: FilterState }) => (
  <Bar>
    <Label>Статус</Label>
    <GroupWrap>
      <Radio.Group
        value={props.filters.state.processed}
        onChange={(e) => props.filters.update({ processed: e.target.value })}
      >
        <Radio.Button value="all">Все</Radio.Button>
        <Radio.Button value="unprocessed">Не обработано</Radio.Button>
        <Radio.Button value="processed">Обработано</Radio.Button>
      </Radio.Group>
    </GroupWrap>
  </Bar>
);
